import { render, staticRenderFns } from "./AudioAttachment.vue?vue&type=template&id=8b523d8c&"
import script from "./AudioAttachment.vue?vue&type=script&lang=js&"
export * from "./AudioAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports